// Пример реализации боковой панели на основе наследования от collection.Item.
// Боковая панель отображает информацию, которую мы ей передали.
window.addEventListener("turbo:load", () => {
    if (!window.ymaps) return

    ymaps.modules.define('Panel', [
        'util.augment',
        'collection.Item'
    ], function (provide, augment, item) {
        // Создаем собственный класс.
        var Panel = function (options) {
            Panel.superclass.constructor.call(this, options);
        };

        // И наследуем его от collection.Item.
        augment(Panel, item, {
            onAddToMap: function (map) {
                Panel.superclass.onAddToMap.call(this, map);
                this.getParent().getChildElement(this).then(this._onGetChildElement, this);
                // Добавим отступы на карту.
                // Отступы могут учитываться при установке текущей видимой области карты,
                // чтобы добиться наилучшего отображения данных на карте.
                map.margin.addArea({
                    top: 0,
                    left: 0,
                    width: '250px',
                    height: '100%'
                })
            },

            onRemoveFromMap: function (oldMap) {
                if (this._$control) {
                    this._$control.remove();
                }
                Panel.superclass.onRemoveFromMap.call(this, oldMap);
            },

            _onGetChildElement: function (parentDomContainer) {
                // Создаем HTML-элемент с текстом.
                // По-умолчанию HTML-элемент скрыт.
                this._$control = $('<div class="zone-form"><div class="content"></div></div>').appendTo(parentDomContainer);
                this._$content = $('.content');
            },
            _onClose: function () {
                $('.zone-form').css('display', 'none');
            },
            // Метод задания контента панели.
            setContent: function (text) {
                // При задании контента будем показывать панель.
                this._$control.css('display', 'flex');
                this._$content.html(text);
            }
        });

        provide(Panel);
    });
})
